export const ADDPRODUCT = "product/addProduct";
export const ADDCART = "product/addCart";
export const INCREASEQUANTITY = "product/increaseQuantity";
export const DECREASEQUANTITY = "product/decreaseQuantity";
export const DELETEPRODUCTCART = "product/deleteProductCart";
